import { render } from "./ListAntrianDokter.vue?vue&type=template&id=60936fc6"
import script from "./ListAntrianDokter.vue?vue&type=script&lang=js"
export * from "./ListAntrianDokter.vue?vue&type=script&lang=js"

import "./ListAntrianDokter.vue?vue&type=style&index=0&id=60936fc6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__